import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { Fragment } from "react/jsx-runtime";
import { useEmailInboxPreview } from "./use-email-inbox-preview";
import { EmailInboxDetails } from "./email-inbox-details";

export const EmailInboxPreview = () => {
  const { archive_id } = useParams<{ archive_id: string }>();
  const navigate = useNavigate();
  const { emailInbox, loading } = useEmailInboxPreview(archive_id);

  return (
    <Fragment>
      <div className="flex flex-col gap-5">
        <ListPageTopBar title="Email Inbox">
          <Button
            variant={"action"}
            onClick={() => {
              sessionStorage.setItem("email_inbox_return_from_preview", "1");
              navigate(-1);
            }}
          >
            <ArrowLeftIcon /> Back
          </Button>
        </ListPageTopBar>

        <EmailInboxDetails emailInbox={emailInbox} loading={loading} />
      </div>
    </Fragment>
  );
};
